export default __webpack_public_path__ + "static/media/BumpNormalMap.8e6e3f50.png";